import * as React from 'react';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';
import { Field, reduxForm, FormProps, InjectedFormProps } from 'redux-form';

interface ChangePasswordProps extends FormProps<InjectedFormProps, {}> {
  headerActions?: any;
  password: any;
  changePasswordForm: any;
  passwordActions: any;
  dialogActions?: any;
}

class ChangePasswordForm extends React.Component<ChangePasswordProps, {}> {
  static propTypes = {
    password: PropTypes.any.isRequired,
    passwordActions: PropTypes.any.isRequired,
  };

  private focusForm: any;

  componentDidmount() {
    this.focusForm.getRenderedComponment().focus();
  }

  handleChangeOldPassword(event: any) {
    // do nothing
  }

  handleChangeNewPassword(event: any) {
    // do nothing
  }

  handleChangeConfirmation(event: any) {
    // do nothing
  }

  handleSubmit(event: React.FormEvent<HTMLInputElement|HTMLFormElement>) {
    event.preventDefault();
    if (typeof(this.props.changePasswordForm) === 'undefined') {
      return;
    }

    // undefinedになってた時に最低空文字にしてcognite側で判断させる
    const oldPassword = this.props.changePasswordForm.oldPassword || '';
    const newPassword = this.props.changePasswordForm.newPassword || '';
    const confirmation = this.props.changePasswordForm.confirmation || '';

    this.props.passwordActions.changePassword(
      oldPassword,
      newPassword,
      confirmation,
      (res: any, message: string) => {
        if (res === false) {
          alert(message);
        }
      }
    );
  }

  render() {
    return (
      <div>
        <div id="changePasswordForm" className="changePassword">
          <h2>パスワードを変更する</h2>
          <form>
            <div id="message" className="alert" style={{display: 'none'}} />
            <table className="changePasswordForm">
              <tbody>
                <tr>
                  <th>現在のパスワード</th>
                  <td>
                    <Field
                      id="inputOldPassword"
                      name="oldPassword"
                      type="password"
                      component="input"
                      placeholder="現在のパスワード"
                      required={true}
                      autoFocus={true}
                      ref={(input: any) => { this.focusForm = input; }}
                      onChange={(e) => this.handleChangeOldPassword(e)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>変更後のパスワード</th>
                  <td>
                    <Field
                      id="newPassword"
                      name="newPassword"
                      type="password"
                      component="input"
                      placeholder="変更後のパスワード"
                      required={true}
                      onChange={(event) => this.handleChangeNewPassword(event)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>(確認用)変更後のパスワード</th>
                  <td>
                    <Field
                      id="confirmation"
                      name="confirmation"
                      type="password"
                      component="input"
                      placeholder="(確認用)変更後のパスワード"
                      required={true}
                      onChange={(event) => this.handleChangeConfirmation(event)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>&nbsp;</th>
                  <td>
                    <input
                      type="button"
                      className="btnStyle01"
                      value="パスワード変更"
                      id="changePasswordButton"
                      onClick={(event) => this.handleSubmit(event)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'changePasswordForm'
})(ChangePasswordForm as any);



// WEBPACK FOOTER //
// ./src/components/ChangePasswordForm.tsx